import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css'; // If you have a global stylesheet
import App from './App'; // Your main App component

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
